import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { API, resolveImg } from "@/lib/store";

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    document.title = "Gallery | Knoble Rides Bicycle Store Mangoro Lagos";
    axios.get(`${API}/gallery`).then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  const close = useCallback(() => setActive(null), []);
  const move = useCallback((dir) => {
    setActive((i) => {
      if (i === null) return i;
      return (i + dir + photos.length) % photos.length;
    });
  }, [photos.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") move(1);
      if (e.key === "ArrowLeft") move(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [close, move]);

  return (
    <div>
      <section className="bg-[#0B0A09] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <span className="kn-overline text-[#e0b48a]">Our Store</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white sm:text-5xl">Gallery</h1>
          <p className="mt-4 max-w-2xl text-lg text-zinc-300">Real photos of our bikes and store at Mangoro, along Abeokuta Express Road, Lagos.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        {photos.length === 0 ? (
          <p className="text-center text-zinc-500">No photos yet.</p>
        ) : (
          <div className="columns-2 gap-3 sm:gap-4 md:columns-3 lg:columns-4">
            {photos.map((p, i) => (
              <button
                key={p.id}
                data-testid={`gallery-image-${i}`}
                onClick={() => setActive(i)}
                className="mb-3 block w-full overflow-hidden rounded-xl border border-[#E6D7C8] bg-[#F1ECE6] sm:mb-4"
              >
                <img
                  src={resolveImg(p.image_url)}
                  alt={p.caption || `Knoble Rides bikes store Lagos photo ${i + 1}`}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </button>
            ))}
          </div>
        )}
      </section>

      {active !== null && photos[active] && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4" onClick={close}>
          <button onClick={close} className="absolute right-5 top-5 rounded-full bg-white/10 p-2 text-white hover:bg-white/20" aria-label="Close">
            <X className="h-6 w-6" />
          </button>
          <button onClick={(e) => { e.stopPropagation(); move(-1); }} className="absolute left-4 rounded-full bg-white/10 p-3 text-white hover:bg-white/20" aria-label="Previous">
            <ChevronLeft className="h-6 w-6" />
          </button>
          <img
            src={resolveImg(photos[active].image_url)}
            alt={photos[active].caption || "Knoble Rides gallery"}
            className="max-h-[85vh] max-w-full rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button onClick={(e) => { e.stopPropagation(); move(1); }} className="absolute right-4 rounded-full bg-white/10 p-3 text-white hover:bg-white/20" aria-label="Next">
            <ChevronRight className="h-6 w-6" />
          </button>
        </div>
      )}
    </div>
  );
}
